import React, { useState, useMemo } from "react";
import styled from "@emotion/styled";
import { Box, InputBase } from "@mui/material";

import { SearchIcon } from "components/Icons";
import { Typography } from "components/Typography";
import { TeamDataGrid } from "./component/TeamDataGrid";
import { InviteTeamMate } from "./component/InviteTeamMate";
import { useGetTeamsQuery } from "api/teammates";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  paddingLeft: "7px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  border: "1.5px solid #EFF1F4",
  borderRadius: "8px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
  },
}));

export const Team = () => {
  const { data = [], isLoading } = useGetTeamsQuery();
  const [searchQuery, setSearchQuery] = useState("");

  const filteredData = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return data.filter((item) =>
      Object.values(item).some((val) => {
        if (typeof val === "string") {
          return val.toLowerCase().includes(query);
        }
        return false;
      })
    );
  }, [searchQuery, data]);

  return (
    <>
      <Wrapper
        sx={{
          justifyContent: "space-between",
          marginBottom: 3,
        }}
      >
        <Wrapper>
          <Typography variant="dashboardHeading">Team mates</Typography>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Search>
        </Wrapper>

        <InviteTeamMate />
      </Wrapper>
      <Box>
        <TeamDataGrid data={filteredData} loading={isLoading} />
      </Box>
    </>
  );
};
